import axios, { InternalAxiosRequestConfig } from "axios";
import { BASE_API_URL } from "./const";

// Создаем экземпляр axios
const api = axios.create({
  baseURL: BASE_API_URL,
});

// Интерцептор для добавления токена в каждый запрос
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem("mediateka.Token");
    if (token) {
      // Приводим headers к нужному типу
      config.headers = config.headers ?? {};
      (config.headers as Record<string, string>)["http-x-token"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
